export default ({ fill = "#111928", size = "18" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7078_66727)">
      <path
        d="M12.5332 8.2793C12.7828 8.43398 12.9375 8.70469 12.9375 9C12.9375 9.29531 12.7828 9.56602 12.5332 9.7207L7.4707 12.8145C7.21055 12.9727 6.88359 12.9797 6.61992 12.8285C6.35273 12.6809 6.1875 12.3996 6.1875 12.0938V5.87461C6.1875 5.60039 6.35273 5.31914 6.61992 5.17148C6.88359 5.02031 7.21055 4.9957 7.4707 5.18555L12.5332 8.2793ZM7.3125 6.40898V11.591L11.5559 8.96836L7.3125 6.40898ZM0 9C0 4.02891 4.02891 0 9 0C13.9711 0 18 4.02891 18 9C18 13.9711 13.9711 18 9 18C4.02891 18 0 13.9711 0 9ZM9 16.875C13.3488 16.875 16.875 13.3488 16.875 9C16.875 4.65117 13.3488 1.125 9 1.125C4.65117 1.125 1.125 4.65117 1.125 9C1.125 13.3488 4.65117 16.875 9 16.875Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_7078_66727">
        <rect width={size} height={size} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
